import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Fragment } from 'react';
import { PanelItem } from '../../panels/panelItem';
import { PanelItemDivider } from '../../panels/panelItemDivider';
import { MODAL_HEADER_BACKGROUND_COLOR } from '../../styles/colors';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
`;
const VALUE_CSS = css `
  color: #aaa;
`;
export const RecordMessageBoxContents = ({ fields }) => {
    return (_jsx("div", { css: CONTAINER_CSS, children: Object.entries(fields).map(([key, value], i) => (_jsxs(Fragment, { children: [i > 0 && _jsx(PanelItemDivider, { color: MODAL_HEADER_BACKGROUND_COLOR, thicknessPx: 2, marginPx: 0 }), _jsxs(PanelItem, { flexWrap: true, children: [_jsx("span", { children: key }), _jsx("span", { css: VALUE_CSS, children: value })] })] }, key))) }));
};
